import type { IconData } from '@stacksjs/iconify-core'

export const musicAlbumCdDiskPlaylist: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 12.185H32v7.62h-1.52Zm-1.52 7.62h1.52v3.05h-1.52Zm0-10.66h1.52v3.04h-1.52Zm-1.53 13.71h1.53v1.52h-1.53Zm0-10.67h1.53v1.53h-1.53Zm0-4.57h1.53v1.53h-1.53Zm-1.52 3.05h1.52v1.52h-1.52Z\"/><path fill=\"currentColor\" d=\"M24.38 18.285h1.53v-4.57h-1.53v-6.1h3.05v-1.52h-3.05v-1.53h-1.52v22.86h1.52v-1.52h3.05v-1.53h-3.05zm-22.85 9.14h21.33v1.53H1.53Zm16.76-12.19h-3.05v1.52h-1.52v3.05h1.52v1.53h3.05v-1.53h1.52V9.145h-1.52Zm0 3.05h-1.52v-1.53h1.52Zm-3.05-10.67h3.05v1.53h-3.05Zm-3.05 1.53h3.05v1.52h-3.05Zm-3.04 1.52h3.04v1.52H9.15Zm-1.53 7.62H4.58v1.52H3.05v3.05h1.53v1.52h3.04v-1.52h1.53v-10.67H7.62Zm0 3.05H6.1v-1.53h1.52ZM1.53 3.045h21.33v1.52H1.53ZM0 4.565h1.53v22.86H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default musicAlbumCdDiskPlaylist
